export default __webpack_public_path__ + "static/img01-1c6a4c2e87cc90f4221d88f2441aea6a.svg";